var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPointToRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.722,
    height: 13.546,
    viewBox: "0 0 7.722 13.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#9b9b9b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-point-to-right_1_",
    "data-name": "arrow-point-to-right (1)",
    transform: "translate(-97.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M104.582 7.443l-5.825 5.824a.949.949 0 1 1-1.342-1.341l5.154-5.154-5.153-5.153A.949.949 0 0 1 98.758.278l5.825 5.822a.948.948 0 0 1 0 1.341z",
    className: "cls-1",
    "data-name": "Path 40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPointToRight);
export default __webpack_public_path__ + "static/media/arrow-point-to-right.477d8fbf.svg";
export { ForwardRef as ReactComponent };